import { useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import AdminHeader from '../components/AdminHeader';
import BrandingSettings from './components/BrandingSettings';
import FeaturesSettings from './components/FeaturesSettings';
import FooterSettings from './components/FooterSettings';

export default function AdminSettingsPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('branding');

  const tabs = [
    { id: 'branding', label: 'Branding', icon: 'ri-palette-line' },
    { id: 'features', label: 'Features Section', icon: 'ri-star-line' },
    { id: 'footer', label: 'Footer', icon: 'ri-layout-bottom-line' }
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] font-['Poppins']">
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <AdminSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="lg:ml-64 min-h-screen">
        <AdminHeader onMenuClick={() => setIsSidebarOpen(true)} />
        
        <main className="p-4 md:p-6 lg:p-8">
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Site Settings</h1>
            <p className="text-sm text-gray-600">Manage your site branding, features, and footer content</p>
          </div>

          {/* Tabs */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
            <div className="flex overflow-x-auto">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-6 py-4 border-b-2 transition-colors whitespace-nowrap cursor-pointer ${
                    activeTab === tab.id
                      ? 'border-lilac-400 text-lilac-400'
                      : 'border-transparent text-gray-600 hover:text-gray-900'
                  }`}
                >
                  <i className={`${tab.icon} text-lg`}></i>
                  <span className="font-medium text-sm">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            {activeTab === 'branding' && <BrandingSettings />}
            {activeTab === 'features' && <FeaturesSettings />}
            {activeTab === 'footer' && <FooterSettings />}
          </div>
        </main>
      </div>
    </div>
  );
}
